import projectOptions from "../project-options";

export default function injectGlobalStyle() {
  const { buttonColor } = projectOptions.default.style.product;

  document.documentElement.style.setProperty(
    "--live-button-color",
    buttonColor
  );
}
